import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faX} from '@fortawesome/free-solid-svg-icons'; // O far para regular

@Component({
  selector: 'app-post-registration-welcome',
  templateUrl: './post-registration-welcome.component.html',
  styleUrls: ['./post-registration-welcome.component.scss']
})
export class PostRegistrationWelcomeComponent {
  faClose= faX;
  constructor(public activeModal: NgbActiveModal,
  ) {}
  close() {
    this.activeModal.close('close');
  }
}
